export enum ParamethorContextTypeEnum {
  CATEGORY = 'CATEGORY',
  COUNTRY_CODE = 'COUNTRY_CODE',
  EMAIL = 'EMAIL',
  ENV = 'ENV',
  LANGUAGE = 'LANGUAGE',
  MODE = 'MODE',
  SHOP_ID = 'SHOP_ID',
  SKU = 'SKU',
}

export enum ParamethorEnum {
  BACK_OFFICE_TEST_MODE = 'BACK_OFFICE_TEST_MODE',
  BACK_OFFICE_WIDGET = 'BACK_OFFICE_WIDGET',
  BACK_OFFICE_CIS = 'BACK_OFFICE_CIS',
  BACK_OFFICE_CALENDAR_ANIMATIONS = 'BACK_OFFICE_CALENDAR_ANIMATIONS',
  BACK_OFFICE_EDIT_APPOINTMENT = 'BACK_OFFICE_EDIT_APPOINTMENT',
  BACK_OFFICE_SSE_NOTIFICATIONS = 'BACK_OFFICE_SSE_NOTIFICATIONS',
  BACK_OFFICE_SCHEDULE_AVAILABILITY = 'BACK_OFFICE_SCHEDULE_AVAILABILITY',
  BACK_OFFICE_SCHEDULE_UNAVAILABILITY = 'BACK_OFFICE_SCHEDULE_UNAVAILABILITY',
  BACK_OFFICE_SCHEDULE_ASSOCIATED_SERVICES = 'BACK_OFFICE_SCHEDULE_ASSOCIATED_SERVICES',
  BACK_OFFICE_SERVICE_DETAILS = 'BACK_OFFICE_SERVICE_DETAILS',
  BACK_OFFICE_SERVICE_DETAILS_MINIMAL_DELAY = 'BACK_OFFICE_SERVICE_DETAILS_MINIMAL_DELAY',
  BACK_OFFICE_SERVICE_DETAILS_START_TIME_INTERVAL = 'BACK_OFFICE_SERVICE_DETAILS_START_TIME_INTERVAL',
  BACK_OFFICE_SERVICE_AVAILABILITY = 'BACK_OFFICE_SERVICE_AVAILABILITY',
  BACK_OFFICE_CUSTOM_COUNTRY_SERVICES = 'BACK_OFFICE_CUSTOM_COUNTRY_SERVICES',
  BACK_OFFICE_CREATE_PANEL = 'BACK_OFFICE_CREATE_PANEL',
  BACK_OFFICE_FORCE_STORE = 'BACK_OFFICE_FORCE_STORE',
  BACK_OFFICE_SWITCH_CONTEXT = 'BACK_OFFICE_SWITCH_CONTEXT',
  WIDGET_DIDOMI_CONSENT = 'WIDGET_DIDOMI_CONSENT',
  WIDGET_TERMS_AND_CONDITIONS = 'WIDGET_TERMS_AND_CONDITIONS',
  WIDGET_HELP_SECTION = 'WIDGET_HELP_SECTION',
  WIDGET_WHATS_NEXT_SECTION = 'WIDGET_WHATS_NEXT_SECTION',
  WIDGET_HOME_PAGE = 'WIDGET_HOME_PAGE',
  WIDGET_SEARCHABLE_STORE_LIST = 'WIDGET_SEARCHABLE_STORE_LIST',
  WIDGET_HIDE_TEST_E_BIKE = 'WIDGET_HIDE_TEST_E_BIKE',
  PRODUCT_SHEETS_SORTING = 'PRODUCT_SHEETS_SORTING',
  WIDGET_REQUEST_PHONE_NUMBER = 'WIDGET_REQUEST_PHONE_NUMBER',
  WIDGET_REQUEST_ORDER_NUMBER = 'WIDGET_REQUEST_ORDER_NUMBER',
  WIDGET_REQUEST_LEASING_NUMBER = 'WIDGET_REQUEST_LEASING_NUMBER',
  WIDGET_INFOS_STEP_CUSTOM_DESCRIPTION = 'WIDGET_INFOS_STEP_CUSTOM_DESCRIPTION',
  WIDGET_HIDE_SERVICES = 'WIDGET_HIDE_SERVICES',
  WIDGET_HIDE_SERVICE_PRICES = 'WIDGET_HIDE_SERVICE_PRICES',
  WIDGET_DISPLAY_REDIRECT_BANNER = 'WIDGET_DISPLAY_REDIRECT_BANNER',
  WIDGET_DISPLAY_REDIRECT_BANNER_CH = 'WIDGET_DISPLAY_REDIRECT_BANNER_CH',
}
